var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import API from "@irati/utils/services/API";
import { requestTenant } from "@irati/identity/services/tenant";
import { USER, ADMIN } from "@irati/identity/constants/roles";
import endpoints from "../endpoints";
import defaultUser from "../helpers/defaultUser";
import featureFlagsService from "./featureFlags";
import authentication from "../index";
export function ghostLogin(email) {
    var tenant = authentication.userTenant();
    var user = __assign(__assign({}, defaultUser), { uuid: "ghost", firstname: "ghost", email: email, roles: [USER, ADMIN], teams: [] });
    return requestTenant(tenant).then(function (userTenant) {
        return featureFlagsService.get(userTenant).then(function (featureFlags) {
            return {
                user: user,
                featureFlags: featureFlags,
                userTenant: userTenant
            };
        });
    });
}
export function getTenantTokenForGhost(tenantId) {
    return API.post(endpoints.ghostLogin(tenantId)).then(function (res) {
        var access_token = res.data.access_token;
        return access_token;
    });
}
